import React from 'react';
import clsx from 'clsx';
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useUniqueId from 'utils/unique-id';
import ArrowIcon from '../utils/icon/icon-arrow.svg';
import ProductCard from '../product-card/product-card';

const CartUpsell = ({ upsellData, cartEmpty = true }) => {
  const { title, products } = upsellData || {};
  const inputPrefix = useUniqueId();

  if (!products.length) return null;

  return (
    <div
      id={`cart-upsell`}
      className={clsx('cart-upsell relative mt-auto', {
        'border-t border-t-grey-medium pt-6 lg:border-t-0 lg:pt-0': !cartEmpty,
      })}
    >
      <div className="mb-2 flex items-center justify-between px-3 md:px-8">
        {title.length > 0 && <div className="heading-5">{title}</div>}
        <div
          className={clsx('mini-cart__pagination hidden items-center gap-1', {
            'md:flex': products.length > 2,
            'md:hidden': products.length <= 2,
          })}
        >
          <button className="prev flex size-7.5 items-center justify-center rounded-full border border-default p-2 hover:border-brand-tangerine [&>svg]:h-2.5 [&>svg]:w-3 [&>svg]:rotate-180">
            <ArrowIcon />
          </button>
          <button className="next flex size-7.5 items-center justify-center rounded-full border border-default p-2 transition-colors duration-300 hover:border-brand-tangerine [&>svg]:h-2.5 [&>svg]:w-3">
            <ArrowIcon />
          </button>
        </div>
      </div>

      <div className="ml-3 overflow-hidden md:ml-8">
        <Swiper
          modules={[Navigation, FreeMode]}
          navigation={{
            prevEl: `#cart-upsell .mini-cart__pagination .prev`,
            nextEl: `#cart-upsell .mini-cart__pagination .next`,
            disabledClass: '!border-grey-medium',
          }}
          slidesPerView="auto"
          spaceBetween={8}
          freeMode={true}
          loop={false}
          className="!overflow-visible"
        >
          {products.map((product) => (
            <SwiperSlide
              key={product.id}
              className="mb-6 !w-[8.75rem] md:!w-[10.625rem]"
            >
              <ProductCard
                product={product}
                placement="cart"
                inputPrefix={inputPrefix}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CartUpsell;
